export const CURRENCY_LIST = [
  // { label: 'XUA', value: 'XUA' },
  // { label: 'AFN', value: 'AFN' },
  // { label: 'AFA', value: 'AFA' },
  // { label: 'ALL', value: 'ALL' },
  // { label: 'ALK', value: 'ALK' },
  // { label: 'DZD', value: 'DZD' },
  // { label: 'ADP', value: 'ADP' },
  // { label: 'AOA', value: 'AOA' },
  // { label: 'AOK', value: 'AOK' },
  // { label: 'AON', value: 'AON' },
  // { label: 'AOR', value: 'AOR' },
  // { label: 'ARA', value: 'ARA' },
  // { label: 'ARS', value: 'ARS' },
  // { label: 'ARM', value: 'ARM' },
  // { label: 'ARP', value: 'ARP' },
  // { label: 'ARL', value: 'ARL' },
  // { label: 'AMD', value: 'AMD' },
  // { label: 'AWG', value: 'AWG' },
  // { label: 'AUD', value: 'AUD' },
  // { label: 'ATS', value: 'ATS' },
  // { label: 'AZN', value: 'AZN' },
  // { label: 'AZM', value: 'AZM' },
  // { label: 'BSD', value: 'BSD' },
  // { label: 'BHD', value: 'BHD' },
  // { label: 'BDT', value: 'BDT' },
  // { label: 'BBD', value: 'BBD' },
  // { label: 'BYN', value: 'BYN' },
  // { label: 'BYB', value: 'BYB' },
  // { label: 'BYR', value: 'BYR' },
  // { label: 'BEF', value: 'BEF' },
  // { label: 'BEC', value: 'BEC' },
  // { label: 'BEL', value: 'BEL' },
  // { label: 'BZD', value: 'BZD' },
  // { label: 'BMD', value: 'BMD' },
  // { label: 'BTN', value: 'BTN' },
  // { label: 'BOB', value: 'BOB' },
  // { label: 'BOL', value: 'BOL' },
  // { label: 'BOV', value: 'BOV' },
  // { label: 'BOP', value: 'BOP' },
  // { label: 'VED', value: 'VED' },
  // { label: 'BAM', value: 'BAM' },
  // { label: 'BAD', value: 'BAD' },
  // { label: 'BAN', value: 'BAN' },
  // { label: 'BWP', value: 'BWP' },
  // { label: 'BRC', value: 'BRC' },
  // { label: 'BRZ', value: 'BRZ' },
  // { label: 'BRE', value: 'BRE' },
  // { label: 'BRR', value: 'BRR' },
  // { label: 'BRN', value: 'BRN' },
  // { label: 'BRB', value: 'BRB' },
  // { label: 'BRL', value: 'BRL' },
  // { label: 'GBP', value: 'GBP' },
  // { label: 'BND', value: 'BND' },
  // { label: 'BGL', value: 'BGL' },
  // { label: 'BGN', value: 'BGN' },
  // { label: 'BGO', value: 'BGO' },
  // { label: 'BGM', value: 'BGM' },
  // { label: 'BUK', value: 'BUK' },
  // { label: 'BIF', value: 'BIF' },
  // { label: 'XPF', value: 'XPF' },
  // { label: 'KHR', value: 'KHR' },
  // { label: 'CAD', value: 'CAD' },
  // { label: 'CVE', value: 'CVE' },
  // { label: 'KYD', value: 'KYD' },
  // { label: 'XAF', value: 'XAF' },
  // { label: 'CLE', value: 'CLE' },
  // { label: 'CLP', value: 'CLP' },
  // { label: 'CLF', value: 'CLF' },
  // { label: 'CNX', value: 'CNX' },
  // { label: 'CNY', value: 'CNY' },
  // { label: 'CNH', value: 'CNH' },
  // { label: 'COP', value: 'COP' },
  // { label: 'COU', value: 'COU' },
  // { label: 'KMF', value: 'KMF' },
  // { label: 'CDF', value: 'CDF' },
  // { label: 'CRC', value: 'CRC' },
  // { label: 'HRD', value: 'HRD' },
  // { label: 'HRK', value: 'HRK' },
  // { label: 'CUC', value: 'CUC' },
  // { label: 'CUP', value: 'CUP' },
  // { label: 'CYP', value: 'CYP' },
  // { label: 'CZK', value: 'CZK' },
  // { label: 'CSK', value: 'CSK' },
  // { label: 'DKK', value: 'DKK' },
  // { label: 'DJF', value: 'DJF' },
  // { label: 'DOP', value: 'DOP' },
  // { label: 'NLG', value: 'NLG' },
  // { label: 'XCD', value: 'XCD' },
  // { label: 'DDM', value: 'DDM' },
  // { label: 'ECS', value: 'ECS' },
  // { label: 'ECV', value: 'ECV' },
  // { label: 'EGP', value: 'EGP' },
  // { label: 'GQE', value: 'GQE' },
  // { label: 'ERN', value: 'ERN' },
  // { label: 'EEK', value: 'EEK' },
  // { label: 'ETB', value: 'ETB' },
  // { label: 'EUR', value: 'EUR' },
  // { label: 'XBA', value: 'XBA' },
  // { label: 'XEU', value: 'XEU' },
  // { label: 'XBB', value: 'XBB' },
  // { label: 'XBC', value: 'XBC' },
  // { label: 'XBD', value: 'XBD' },
  // { label: 'FKP', value: 'FKP' },
  // { label: 'FJD', value: 'FJD' },
  // { label: 'FIM', value: 'FIM' },
  // { label: 'FRF', value: 'FRF' },
  // { label: 'XFO', value: 'XFO' },
  // { label: 'XFU', value: 'XFU' },
  // { label: 'GMD', value: 'GMD' },
  // { label: 'GEK', value: 'GEK' },
  // { label: 'GEL', value: 'GEL' },
  // { label: 'DEM', value: 'DEM' },
  // { label: 'GHS', value: 'GHS' },
  // { label: 'GHC', value: 'GHC' },
  // { label: 'GIP', value: 'GIP' },
  // { label: 'XAU', value: 'XAU' },
  // { label: 'GRD', value: 'GRD' },
  // { label: 'GTQ', value: 'GTQ' },
  // { label: 'GWP', value: 'GWP' },
  // { label: 'GNF', value: 'GNF' },
  // { label: 'GNS', value: 'GNS' },
  // { label: 'GYD', value: 'GYD' },
  // { label: 'HTG', value: 'HTG' },
  // { label: 'HNL', value: 'HNL' },
  // { label: 'HKD', value: 'HKD' },
  // { label: 'HUF', value: 'HUF' },
  // { label: 'IMP', value: 'IMP' },
  // { label: 'ISK', value: 'ISK' },
  // { label: 'ISJ', value: 'ISJ' },
  { label: 'INR', value: 'INR' },
  // { label: 'IDR', value: 'IDR' },
  // { label: 'IRR', value: 'IRR' },
  // { label: 'IQD', value: 'IQD' },
  // { label: 'IEP', value: 'IEP' },
  // { label: 'ILS', value: 'ILS' },
  // { label: 'ILP', value: 'ILP' },
  // { label: 'ILR', value: 'ILR' },
  // { label: 'ITL', value: 'ITL' },
  // { label: 'JMD', value: 'JMD' },
  // { label: 'JPY', value: 'JPY' },
  // { label: 'JOD', value: 'JOD' },
  // { label: 'KZT', value: 'KZT' },
  // { label: 'KES', value: 'KES' },
  // { label: 'KWD', value: 'KWD' },
  // { label: 'KGS', value: 'KGS' },
  // { label: 'LAK', value: 'LAK' },
  // { label: 'LVL', value: 'LVL' },
  // { label: 'LVR', value: 'LVR' },
  // { label: 'LBP', value: 'LBP' },
  // { label: 'LSL', value: 'LSL' },
  // { label: 'LRD', value: 'LRD' },
  // { label: 'LYD', value: 'LYD' },
  // { label: 'LTL', value: 'LTL' },
  // { label: 'LTT', value: 'LTT' },
  // { label: 'LUL', value: 'LUL' },
  // { label: 'LUC', value: 'LUC' },
  // { label: 'LUF', value: 'LUF' },
  // { label: 'MOP', value: 'MOP' },
  // { label: 'MKD', value: 'MKD' },
  // { label: 'MKN', value: 'MKN' },
  // { label: 'MGA', value: 'MGA' },
  // { label: 'MGF', value: 'MGF' },
  // { label: 'MWK', value: 'MWK' },
  // { label: 'MYR', value: 'MYR' },
  // { label: 'MVR', value: 'MVR' },
  // { label: 'MVP', value: 'MVP' },
  // { label: 'MLF', value: 'MLF' },
  // { label: 'MTL', value: 'MTL' },
  // { label: 'MTP', value: 'MTP' },
  // { label: 'MRU', value: 'MRU' },
  // { label: 'MRO', value: 'MRO' },
  // { label: 'MUR', value: 'MUR' },
  // { label: 'MXV', value: 'MXV' },
  // { label: 'MXN', value: 'MXN' },
  // { label: 'MXP', value: 'MXP' },
  // { label: 'MDC', value: 'MDC' },
  // { label: 'MDL', value: 'MDL' },
  // { label: 'MCF', value: 'MCF' },
  // { label: 'MNT', value: 'MNT' },
  // { label: 'MAD', value: 'MAD' },
  // { label: 'MAF', value: 'MAF' },
  // { label: 'MZE', value: 'MZE' },
  // { label: 'MZN', value: 'MZN' },
  // { label: 'MZM', value: 'MZM' },
  // { label: 'MMK', value: 'MMK' },
  // { label: 'NAD', value: 'NAD' },
  // { label: 'NPR', value: 'NPR' },
  // { label: 'ANG', value: 'ANG' },
  // { label: 'TWD', value: 'TWD' },
  // { label: 'NZD', value: 'NZD' },
  // { label: 'NIO', value: 'NIO' },
  // { label: 'NIC', value: 'NIC' },
  // { label: 'NGN', value: 'NGN' },
  // { label: 'KPW', value: 'KPW' },
  // { label: 'NOK', value: 'NOK' },
  // { label: 'OMR', value: 'OMR' },
  // { label: 'PKR', value: 'PKR' },
  // { label: 'XPD', value: 'XPD' },
  // { label: 'PAB', value: 'PAB' },
  // { label: 'PGK', value: 'PGK' },
  // { label: 'PYG', value: 'PYG' },
  // { label: 'PEI', value: 'PEI' },
  // { label: 'PEN', value: 'PEN' },
  // { label: 'PES', value: 'PES' },
  // { label: 'PHP', value: 'PHP' },
  // { label: 'XPT', value: 'XPT' },
  // { label: 'PLN', value: 'PLN' },
  // { label: 'PLZ', value: 'PLZ' },
  // { label: 'PTE', value: 'PTE' },
  // { label: 'GWE', value: 'GWE' },
  // { label: 'QAR', value: 'QAR' },
  // { label: 'XRE', value: 'XRE' },
  // { label: 'RHD', value: 'RHD' },
  // { label: 'RON', value: 'RON' },
  // { label: 'ROL', value: 'ROL' },
  // { label: 'RUB', value: 'RUB' },
  // { label: 'RUR', value: 'RUR' },
  // { label: 'RWF', value: 'RWF' },
  // { label: 'SVC', value: 'SVC' },
  // { label: 'WST', value: 'WST' },
  // { label: 'SAR', value: 'SAR' },
  // { label: 'RSD', value: 'RSD' },
  // { label: 'CSD', value: 'CSD' },
  // { label: 'SCR', value: 'SCR' },
  // { label: 'SLE', value: 'SLE' },
  // { label: 'SLL', value: 'SLL' },
  // { label: 'XAG', value: 'XAG' },
  // { label: 'SGD', value: 'SGD' },
  // { label: 'SKK', value: 'SKK' },
  // { label: 'SIT', value: 'SIT' },
  // { label: 'SBD', value: 'SBD' },
  // { label: 'SOS', value: 'SOS' },
  // { label: 'ZAR', value: 'ZAR' },
  // { label: 'ZAL', value: 'ZAL' },
  // { label: 'KRH', value: 'KRH' },
  // { label: 'KRW', value: 'KRW' },
  // { label: 'KRO', value: 'KRO' },
  // { label: 'SSP', value: 'SSP' },
  // { label: 'SUR', value: 'SUR' },
  // { label: 'ESP', value: 'ESP' },
  // { label: 'ESA', value: 'ESA' },
  // { label: 'ESB', value: 'ESB' },
  // { label: 'XDR', value: 'XDR' },
  // { label: 'LKR', value: 'LKR' },
  // { label: 'SHP', value: 'SHP' },
  // { label: 'XSU', value: 'XSU' },
  // { label: 'SDD', value: 'SDD' },
  // { label: 'SDG', value: 'SDG' },
  // { label: 'SDP', value: 'SDP' },
  // { label: 'SRD', value: 'SRD' },
  // { label: 'SRG', value: 'SRG' },
  // { label: 'SZL', value: 'SZL' },
  // { label: 'SEK', value: 'SEK' },
  // { label: 'CHF', value: 'CHF' },
  // { label: 'SYP', value: 'SYP' },
  // { label: 'STN', value: 'STN' },
  // { label: 'STD', value: 'STD' },
  // { label: 'TVD', value: 'TVD' },
  // { label: 'TJR', value: 'TJR' },
  // { label: 'TJS', value: 'TJS' },
  // { label: 'TZS', value: 'TZS' },
  // { label: 'XTS', value: 'XTS' },
  // { label: 'THB', value: 'THB' },
  // { label: 'TPE', value: 'TPE' },
  // { label: 'TOP', value: 'TOP' },
  // { label: 'TTD', value: 'TTD' },
  // { label: 'TND', value: 'TND' },
  // { label: 'TRY', value: 'TRY' },
  // { label: 'TRL', value: 'TRL' },
  // { label: 'TMT', value: 'TMT' },
  // { label: 'TMM', value: 'TMM' },
  // { label: 'USD', value: 'USD' },
  // { label: 'USN', value: 'USN' },
  // { label: 'USS', value: 'USS' },
  // { label: 'UGX', value: 'UGX' },
  // { label: 'UGS', value: 'UGS' },
  // { label: 'UAH', value: 'UAH' },
  // { label: 'UAK', value: 'UAK' },
  // { label: 'AED', value: 'AED' },
  // { label: 'UYW', value: 'UYW' },
  // { label: 'UYU', value: 'UYU' },
  // { label: 'UYP', value: 'UYP' },
  // { label: 'UYI', value: 'UYI' },
  // { label: 'UZS', value: 'UZS' },
  // { label: 'VUV', value: 'VUV' },
  // { label: 'VES', value: 'VES' },
  // { label: 'VEB', value: 'VEB' },
  // { label: 'VEF', value: 'VEF' },
  // { label: 'VND', value: 'VND' },
  // { label: 'VNN', value: 'VNN' },
  // { label: 'CHE', value: 'CHE' },
  // { label: 'CHW', value: 'CHW' },
  // { label: 'XOF', value: 'XOF' },
  // { label: 'YDD', value: 'YDD' },
  // { label: 'YER', value: 'YER' },
  // { label: 'YUN', value: 'YUN' },
  // { label: 'YUD', value: 'YUD' },
  // { label: 'YUM', value: 'YUM' },
  // { label: 'YUR', value: 'YUR' },
  // { label: 'ZWN', value: 'ZWN' },
  // { label: 'ZRN', value: 'ZRN' },
  // { label: 'ZRZ', value: 'ZRZ' },
  // { label: 'ZMW', value: 'ZMW' },
  // { label: 'ZMK', value: 'ZMK' },
  // { label: 'ZWD', value: 'ZWD' },
  // { label: 'ZWR', value: 'ZWR' },
  // { label: 'ZWL', value: 'ZWL' },
];
